(function () {
    'use strict';

    function labelDots(carousel) {
    var dots = carousel.querySelectorAll('.owl-dots .owl-dot');
    dots.forEach(function (dot, i) {
    if (!dot.hasAttribute('aria-label')) {
    dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
    }
    });
    }

    function fixNav(carousel) {
    var prev = carousel.querySelector('.owl-prev');
    var next = carousel.querySelector('.owl-next');
    if (prev) {
    prev.removeAttribute('role');
    if (!prev.hasAttribute('aria-label')) { prev.setAttribute('aria-label', 'Previous slide'); }
    }
    if (next) {
    next.removeAttribute('role');
    if (!next.hasAttribute('aria-label')) { next.setAttribute('aria-label', 'Next slide'); }
    }
    }

    function fixListStructure(carousel) {
    var stage = carousel.querySelector('.owl-stage');
    var sourceList = carousel.querySelector('ul[role="list"]');
    if (stage) {
    stage.setAttribute('role', 'list');
    var items = stage.querySelectorAll('.owl-item');
    items.forEach(function (item) {
    item.setAttribute('role', 'listitem');
    });
    }
    if (sourceList) {
    sourceList.removeAttribute('role');
    sourceList.removeAttribute('aria-label');
    }
    }

    function patch(carousel) {
    labelDots(carousel);
    fixNav(carousel);
    fixListStructure(carousel);
    }

    function patchAll() {
    var carousels = document.querySelectorAll('.owl-carousel.owl-loaded');
    carousels.forEach(patch);
    }

    var observer = new MutationObserver(function () {
    patchAll();
    });
    observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class']
    });

    document.addEventListener('DOMContentLoaded', patchAll);
    window.addEventListener('load', patchAll);
    setTimeout(patchAll, 1500);
    setTimeout(patchAll, 3500);
    })();